import { Routes } from '@angular/router';
import { MainLayout } from './shared/components/layouts/main-layout/main-layout';
import { AuthGuard } from 'core/guards/auth.guard';
import { UnAuthGuard } from 'core/guards/unauth.guard';
import { SITE_ROUTES } from 'shared/enums/routes.enum';
import { AuthLayout } from 'shared/components/layouts/auth-layout/auth-layout';
import { PAGES_PERMISSIONS } from 'shared/enums/permissions.enum';

export const routes: Routes = [
    {
        path: 'app',
        component: MainLayout,
        children: [
            {
                path: 'dashboard',
                loadChildren: () => import('./features/dashboard/dashboard.routes')
                    .then(m => m.DASHBOARD_ROUTES),
                data: {
                    permissions: PAGES_PERMISSIONS.DASHBOARD
                }
            },
            {
                path: 'companies',
                loadChildren: () => import('./features/companies/companies.routes')
                    .then(m => m.COMPANIES_ROUTES),
                data: {
                    permissions: PAGES_PERMISSIONS.COMPANIES_LISTING
                }
            },
            {
                path: 'users',
                loadChildren: () => import('./features/users/users.routes')
                    .then(m => m.USERS_ROUTES),
                data: {
                    permissions: PAGES_PERMISSIONS.USERS_LISTING
                }
            },
            {
                path: 'packages',
                loadChildren: () => import('./features/packages/packages.routes')
                    .then(m => m.PACKAGE_ROUTES),
                data: {
                    permissions: PAGES_PERMISSIONS.PACKAGES_LISTING
                }
            },
            {
                path: 'partners',
                loadChildren: () => import('./features/partners/partners.routes')
                    .then(m => m.PARTNERS_ROUTES),
                data: {
                    permissions: PAGES_PERMISSIONS.PARTNERS_LISTING
                }
            },
            {
                path: 'contact-messages',
                loadChildren: () => import('./features/contact-messages/contact.messages.routes')
                    .then(m => m.CONTACT_MESSAGES_ROUTES),
                data: {
                    permissions: PAGES_PERMISSIONS.CONTACT_MESSAGES
                }
            },
            {
                path: 'settings',
                loadChildren: () => import('./features/setting/setting.routes')
                    .then(m => m.SETTING_ROUTES),
                data: {
                    permissions: PAGES_PERMISSIONS.SETTINGS
                }
            },
            {
                path: 'policies',
                loadChildren: () => import('./features/policies/policies.routes')
                    .then(m => m.POLICIES_ROUTES),
                data: {
                    permissions: PAGES_PERMISSIONS.POLICIES_LISTING
                }
            },
             {
                path: 'tickets',
                loadChildren: () => import('./features/tickets/tickets.routes')
                    .then(m => m.TICKETS_ROUTES),
                data: {
                    permissions: PAGES_PERMISSIONS.TICKETS_LISTING
                }
            },
            {
                path: '**',
                redirectTo: SITE_ROUTES.LOGIN
            }
        ],
        canActivateChild: [AuthGuard]
    },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: SITE_ROUTES.LOGIN
    },
    {
        path: 'auth',
        component: AuthLayout,
        children: [
            {
                path: '',
                loadChildren: () => import('./features/auth/auth.routes')
                    .then(m => m.AUTH_ROUTES)
            }
        ],
        canActivateChild: [UnAuthGuard]
    },
    {
        path: '**',
        redirectTo: SITE_ROUTES.LOGIN.replace('/', '')
    }
];
